import SmartLockSearch from './SmartLockSearch';

export default SmartLockSearch;
